import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Options extends Component {

    render() { 
        return ( 
            <div className="showtix-section showtix-background__primary-2">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <h1>{strings.options}</h1>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="referred">{strings.referredBy}
                                    <span id="tooltip-referredBy" className="showtix-tooltip">!</span>
                                    <Tooltip placement="top" target="tooltip-referredBy">
                                        {strings.referredByTooltip}
                                    </Tooltip>
                                </label>

                                <div className="showtix-form__input">
                                    <input className="showtix-input" type="text" object="business" name="referred_by" id="referred" value={this.props.register.business.referred_by} onChange={this.props.handleChange} />
                                </div>
                            </div>
                        </div>

                        {/* <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label">{strings.acceptDonation}</label>

                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="donation-1"
                                                object="business"
                                                name="donation"
                                                value="true"
                                                checked={this.props.register.business.donation === true}
                                                onChange={this.props.handleChange}
                                            />
                                            <label className="showtix-label" htmlFor="donation-1">{strings.yes}</label>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input type="radio" className="showtix-input" id="donation-2"
                                                object="business"
                                                name="donation"
                                                value="false"
                                                checked={this.props.register.business.donation === false}
                                                onChange={this.props.handleChange}
                                            /> 
                                            <label className="showtix-label" htmlFor="donation-2">{strings.no}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>

                    {/* <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="donationMessage">{strings.donationMessage}</label>

                                <TextareaCount
                                    id="donationMessage"
                                    maxLength="250"
                                    object="business"
                                    name="donation_message"
                                    value={this.props.register.business.donation_message}
                                    handleChange={this.props.handleChange}
                                />

                            </div>
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="donationReceipt">{strings.donationReceiptMessage}</label>

                                <TextareaCount
                                    id="donationReceipt"
                                    maxLength="250"
                                    object="business"
                                    name="donation_email"
                                    value={this.props.register.business.donation_email}
                                    handleChange={this.props.handleChange}
                                />

                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label">{strings.captureCustomerAddress}</label>

                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="captureAddress-1"
                                                object="business"
                                                name="collect_cust_info"
                                                value="true"
                                                checked={this.props.register.business.collect_cust_info === true}
                                                onChange={this.props.handleChange}
                                            />
                                            <label className="showtix-label" htmlFor="captureAddress-1">{strings.yes}</label>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="captureAddress-2"
                                                object="business"
                                                name="collect_cust_info"
                                                value="false"
                                                checked={this.props.register.business.collect_cust_info === false}
                                                onChange={this.props.handleChange}
                                            /> <label className="showtix-label" htmlFor="captureAddress-2">{strings.no}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label">{strings.allowWillCall}</label>

                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="willcall-1"
                                                object="business"
                                                name="allow_will_call"
                                                value="true"
                                                checked={this.props.register.business.allow_will_call === true}
                                                onChange={this.props.handleChange}
                                            />
                                            <label className="showtix-label" htmlFor="willcall-1">{strings.yes}</label>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="willcall-2"
                                                object="business"
                                                name="allow_will_call"
                                                value="false"
                                                checked={this.props.register.business.allow_will_call === false}
                                                onChange={this.props.handleChange}
                                            /> <label className="showtix-label" htmlFor="willcall-2">{strings.no}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label">{strings.allowRefunds}</label>

                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="refund-1"
                                                object="business"
                                                name="allow_callcenter_refund"
                                                value="true"
                                                checked={this.props.register.business.allow_callcenter_refund === true}
                                                onChange={this.props.handleChange}
                                            />
                                            <label className="showtix-label" htmlFor="refund-1">{strings.yes}</label>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="refund-2"
                                                object="business"
                                                name="allow_callcenter_refund"
                                                value="false"
                                                checked={this.props.register.business.allow_callcenter_refund === false}
                                                onChange={this.props.handleChange}
                                            /> <label className="showtix-label" htmlFor="refund-2">{strings.no}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label">{strings.allowExchanges}</label>

                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="exchange-1"
                                                object="business"
                                                name="allow_callcenter_exchange"
                                                value="true"
                                                checked={this.props.register.business.allow_callcenter_exchange === true}
                                                onChange={this.props.handleChange}
                                            />
                                            <label className="showtix-label" htmlFor="exchange-1">{strings.yes}</label>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="exchange-2"
                                                object="business"
                                                name="allow_callcenter_exchange"
                                                value="false"
                                                checked={this.props.register.business.allow_callcenter_exchange === false}
                                                onChange={this.props.handleChange}
                                            /> <label className="showtix-label" htmlFor="exchange-2">{strings.no}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        )
    }
}

Options.propTypes = {
    register: PropTypes.shape({
        business: PropTypes.shape({
            referred_by: PropTypes.string,
            donation_message: PropTypes.string,
            donation_email: PropTypes.string,
            donation: PropTypes.bool,
            collect_cust_info: PropTypes.bool,
            allow_will_call: PropTypes.bool,
            allow_callcenter_refund: PropTypes.bool,
            allow_callcenter_exchange: PropTypes.bool
        })
    }),
    handleChange: PropTypes.func,
}
 
export default Options;


// WEBPACK FOOTER //
// ./src/components/Registration/Options/Options.js